import { render } from "./voteomatic.vue?vue&type=template&id=b7f65ee8&scoped=true"
import script from "./voteomatic.vue?vue&type=script&lang=js"
export * from "./voteomatic.vue?vue&type=script&lang=js"

import "./voteomatic.vue?vue&type=style&index=0&id=b7f65ee8&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7f65ee8"]])

export default __exports__